import React from "react";
import ReactDOM from "react-dom/client";

import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import DashboardPage from "./pages/adminPages/DashboardPage";
import SuperAdminDashbordPage from "./pages/superAdminPages/SuperAdminDashbordPage";
import AddAdminPage from "./pages/superAdminPages/AddAdminPage";
import AdminListPage from "./pages/superAdminPages/AdminListPage";
import AdminProfilePage from "./pages/superAdminPages/ProfilePage";
import ProfilePage from "./pages/superAdminPages/ProfilePage";
import PartyInfoPage from "./pages/superAdminPages/PartyInfoPage";
import LoginPage from "./pages/LoginPage";
import DetailViewPage from "./pages/superAdminPages/DetailViewPage";
import AddUser from "./pages/adminPages/AddUserPage";
import UserList from "./pages/adminPages/UserListPage";
import Interface from "./pages/adminPages/InterfacePage";
import ProfilePage from "./pages/adminPages/ProfilePage";
import EnquiryListPage from "./pages/adminPages/EnquiryListPage";
import InterfaceViewPage from "./pages/InterfaceViewPage";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/profile-view/:id" element={<InterfaceViewPage />} />
      </Routes>
      <Routes>
        <Route path="/admin/dashboard" element={<SuperAdminDashbordPage />} />
        <Route path="/admin/add-admin" element={<AddAdminPage />} />
        <Route path="/admin/admin-list" element={<AdminListPage />} />
        <Route path="/admin/profile" element={<AdminProfilePage />} />
        <Route path="/admin/party-info" element={<PartyInfoPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/detail-view" element={<DetailViewPage />} />
      </Routes>
      <Routes>
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/add-user" element={<AddUser />} />
        <Route path="/user-list" element={<UserList />} />
        <Route path="/interface" element={<Interface />} />
        <Route path="/profile" element={<ProfilePage />} />
        <Route path="/enquiry" element={<EnquiryListPage />} />
      </Routes>
    </Router>
  );
}

export default App;
